__turbopack_context__.v({
  "Paragraph": "Paragraph-module-scss-module__BHeu4a__Paragraph",
});
